module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABPElEQVQ4je1Qy4rCQBCsH/JifEzIJBGCl5wUFJlRxBDwEgIJXoKCl6CgIJ71Kob8Ze0hZHaXhf2B3YKG7uqequkG/gEA2O/33Gw2bOv7/c7r9crL5cLz+Wz4NE2Z5zl3ux3zPG/4Xq9H13XZ7/fZiq3Xa0ZRxCRJqJQiAJRlSSEEJ5MJgyCglJJa60ZkuVxyMBgQAE6nEw+Hg3HNsszklmWZXAjB2WzW1EopDodD0wSAx+PBOI7Nasfjka7r0vd9ep7H0Wj0Ob9YLOj7PgHgdrtRa02tNZMkMUPz+Zye57Gua5ZlScdxWBRF059Op+Yoq9Xq20Fb2LZNKaXhHccxpgiCgFVVsf1NFEVUSnE8HhMAwjCkEIJSSnY6HXa7Xdq2ze122wi8Xq8fjl/xfD5ZVZWJ9/vNuq5/ffOX8AG6jK7BhObppwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/12build_old.png
// module id = JYdw
// module chunks = 1